import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, makeStyles, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { PictureAsPdf } from '@material-ui/icons';
import { ReactComponent as CSV } from 'img/icons/file-csv.svg';
import { ReactComponent as Export } from 'img/icon-export.svg';
import { ExportTypes } from 'modules/reports/interfaces/export';
import SendReportModal from '../SendReportModal/SendReportModal';
import messages from 'common/messages/messages';
import { snackbar } from 'common/utils/snackbarUtils';
import { IAttachment } from 'modules/employees/interfaces';

interface IExportReportProps {
  exportTypes?: ExportTypes[];
  exportAction?: (data: Record<string, unknown>) => void;
  exportResult?: IAttachment;
  showExportTypes?: ExportTypes[];
}

const useStyles = makeStyles(() => ({
  menuItem: {
    '& > svg': {
      transition: 'fill 0s',
    },
    '&:hover > svg': {
      fill: '#fff',

      '& > path': {
        fill: '#fff',
      },
    },
  },
}));

const ExportReport = ({
  exportAction,
  exportResult,
  exportTypes,
  showExportTypes = [ExportTypes.Pdf, ExportTypes.Csv, ExportTypes.EmailPdf, ExportTypes.EmailCsv],
}: IExportReportProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const closeEmailModal = useCallback(() => setIsEmailModalOpen(false), [setIsEmailModalOpen]);

  useEffect(() => {
    if (exportResult) {
      closeEmailModal();
    }
  }, [exportResult, closeEmailModal]);
  const openMenu = e => {
    setAnchorEl(e.currentTarget);
  };
  const closeMenu = () => {
    setAnchorEl(null);
  };

  const openEmailModal = (): void => {
    setIsEmailModalOpen(true);
  };

  return (
    <Box>
      <Button
        variant="contained"
        className="iconButton--contained"
        startIcon={<Export />}
        endIcon={<ArrowDropDownIcon />}
        onClick={e => {
          openMenu(e);
        }}
      >
        <FormattedMessage {...messages.exportBtn} />
      </Button>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {showExportTypes?.includes(ExportTypes.Pdf) && (
          <MenuItem
            onClick={() => {
              if (exportTypes?.includes(ExportTypes.Pdf) && exportAction) {
                exportAction({ type: ExportTypes.Pdf });
              } else {
                snackbar.warning(intl.formatMessage(messages.notImplementedYet));
              }

              closeMenu();
            }}
            className={classes.menuItem}
          >
            <PictureAsPdf />
            <FormattedMessage {...messages.pdfBtn} />
          </MenuItem>
        )}
        {showExportTypes?.includes(ExportTypes.Csv) && (
          <MenuItem
            onClick={() => {
              if (exportTypes?.includes(ExportTypes.Csv) && exportAction) {
                exportAction({ type: ExportTypes.Csv });
              } else {
                snackbar.warning(intl.formatMessage(messages.notImplementedYet));
              }

              closeMenu();
            }}
            className={classes.menuItem}
          >
            <CSV />
            <FormattedMessage {...messages.csvBtn} />
          </MenuItem>
        )}
        {showExportTypes?.includes(ExportTypes.EmailPdf) && (
          <MenuItem
            onClick={() => {
              if (exportTypes?.includes(ExportTypes.EmailPdf)) {
                openEmailModal();
              } else {
                snackbar.warning(intl.formatMessage(messages.notImplementedYet));
              }
              closeMenu();
            }}
            className={classes.menuItem}
          >
            <PictureAsPdf />
            <FormattedMessage {...messages.emailCsvBtn} />
          </MenuItem>
        )}
        {showExportTypes?.includes(ExportTypes.EmailCsv) && (
          <MenuItem
            onClick={() => {
              if (exportTypes?.includes(ExportTypes.EmailCsv)) {
                openEmailModal();
              } else {
                snackbar.warning(intl.formatMessage(messages.notImplementedYet));
              }
              closeMenu();
            }}
            className={classes.menuItem}
          >
            <CSV />
            <FormattedMessage {...messages.emailPdfBtn} />
          </MenuItem>
        )}
      </Menu>

      <SendReportModal
        onClose={closeEmailModal}
        isOpen={isEmailModalOpen}
        onSubmit={exportAction || (() => {})}
      />
    </Box>
  );
};

export { ExportReport };
